/**
 * This class represents info button - currently used only homepage
 */
import Helper from "../Helper";

export default class InfoButton {

    /**
     * Constructor
     *
     * @param key unique identificator
     */
    constructor(key)
    {
        this.button = $('[data-info-button="' + key + '"]');
        this.contentModal = $('[data-info-button-content="'+key+'"]');
        this.isOpened = false;

        this.init();
    }

    /**
     * Function that inits basic functionality
     */
    init()
    {
        this.button.click(() => {
            if (this.isOpened) {
                this.hide();
            } else {
                this.show();
            }
        })

        this.contentModal.on('hide.bs.modal', (e) => {
            this.isOpened = false;

            if (Helper.isMobileOrLower()) {
                $('body').css({
                    'position': 'relative',
                    'top': 0,
                    'right': 0,
                    'bottom': 0,
                    'left': 0
                })
            }
        })
    }

    /**
     * Function that shows content of info button
     */
    show()
    {
        this.isOpened = true;
        this.contentModal.modal('show');

        if (Helper.isMobileOrLower()) {
            $('body').css({
                'position': 'fixed',
                'top': 0,
                'right': 0,
                'bottom': 0,
                'left': 0
            })
        }
    }

    /**
     * Function that hides content of info button
     */
    hide()
    {
        this.isOpened = false;
        this.contentModal.modal('hide');

        if (Helper.isMobileOrLower()) {
            $('body').css({
                'position': 'relative',
                'top': 0,
                'right': 0,
                'bottom': 0,
                'left': 0
            })
        }
    }
}